
import { tailwindSurfaceFontClass } from 'bits/font'
import { transformCurrentUrl } from 'bits/location'
import { isRegistered } from 'bits/user_model'
import { Component, Getter, namespace, State, Vue, Watch } from 'bits/vue'
import type { User } from 'types'
import ProcessedImage from 'vuecomponents/processed_image.vue'
import SurfaceBuilder from 'vuecomponents/SurfaceBuilder.vue'
import SurfaceTitleDescription from 'vuecomponents/SurfaceTitleDescription.vue'

@Component({
  components: {
    ProcessedImage,
    SurfaceBuilder,
    SurfaceTitleDescription,
  },
})
export default class SurfaceTitle extends Vue {
  @Getter builder!: User
  @Getter title!: string
  @Getter description!: string
  @Getter portrait!: string
  @Getter canIAdminister!: boolean
  @Getter backgroundLuminance!: 'light' | 'dark'
  @Getter colorScheme!: 'light' | 'dark'
  @Getter fontId!: number
  @Getter isMap!: boolean
  @State isEmbedded!: boolean
  @namespace('settings').Action showSettingsPanel!: () => void

  get portraitSize(): number {
    return 48
  }
  get fontClass(): string {
    return tailwindSurfaceFontClass(this.fontId)
  }

  get isBuilderRegistered(): boolean {
    return isRegistered(this.builder)
  }

  get builderProfileUrl(): string {
    return transformCurrentUrl({}, { path: this.builder.username })
  }

  @Watch('title')
  onTitleChanged(): void {
    this.$emit('title-changed')
  }

  @Watch('description')
  onDescriptionChanged(): void {
    this.$emit('description-changed')
  }

  @Watch('portrait')
  onPortraitChanged(): void {
    this.$emit('portrait-changed')
  }

  tryModify(): void {
    if (this.canIAdminister) {
      this.showSettingsPanel()
    }
  }
}
